import { render, staticRenderFns } from "./manageParcel.vue?vue&type=template&id=7cc3f89e&scoped=true&"
import script from "./manageParcel.vue?vue&type=script&lang=js&"
export * from "./manageParcel.vue?vue&type=script&lang=js&"
import style0 from "./manageParcel.vue?vue&type=style&index=0&id=7cc3f89e&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7cc3f89e",
  null
  
)

export default component.exports